import React from "react";
import Select from "react-select";
import './Select.scss'

export const ReactSelect = ({ className, placeholder,
    options, value,
    onChange, isMulti,
    menuIsOpen, isDisabled, defaultValue, label, htmlFor, errors, isOptionDisabled, isClearable
}: any) => {
    const handleChange = (option: any) => {
        onChange(option);
    };
    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            border: state.isFocused ? '1px solid #337ab7;' : provided.border,
            boxShadow: state.isFocused ? 'none' : provided.boxShadow,
        }),
        valueContainer: (provided: any, state: any) => ({
            ...provided,
            height: "42px",
            overflowY: 'scroll',
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: 5,
        }),
    };

    return (
        <>
            {label && <label className='inputs-label mb-2 fs-16 fw-600  secondary-color' htmlFor={htmlFor}>{label}</label>}
            <Select
                isDisabled={isDisabled}
                menuIsOpen={menuIsOpen}
                className={`multi_select ${className}`}
                // name={field.name}
                defaultValue={defaultValue}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                options={options}
                isMulti={isMulti}
                isSearchable={true}
                styles={customStyles}
                isOptionDisabled={isOptionDisabled}
                isClearable={isClearable}
            />
            {errors && <span className="error-text">{errors}</span>}
        </>
    );
};

export default ReactSelect;
